/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../public/upgrade/shared/sara-input/sara-input-a2.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from '@angular/forms/src/directives/control_value_accessor';
import * as import10 from '../../../../node_modules/@angular/common/src/directives/ng_class.ngfactory';
import * as import11 from '@ngx-translate/core/src/translate.pipe';
import * as import12 from '@angular/core/src/linker/view_container';
import * as import13 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import14 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import15 from '@angular/core/src/linker/element_ref';
import * as import16 from '@ngx-translate/core/src/translate.service';
import * as import17 from '@angular/common/src/directives/ng_class';
import * as import18 from '../../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import19 from '../../../../node_modules/@angular/forms/src/directives/default_value_accessor.ngfactory';
import * as import20 from '../../../../node_modules/@angular/forms/src/directives/validators.ngfactory';
import * as import21 from '../../../../node_modules/@angular/forms/src/directives/ng_model.ngfactory';
import * as import22 from '../../../../node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import23 from '@angular/core/src/linker/template_ref';
import * as import24 from '@angular/common/src/directives/ng_if';
import * as import25 from '@angular/forms/src/directives/default_value_accessor';
import * as import26 from '@angular/forms/src/directives/validators';
import * as import27 from '@angular/forms/src/validators';
import * as import28 from '@angular/forms/src/directives/ng_model';
import * as import29 from '@angular/forms/src/directives/ng_control';
import * as import30 from '@angular/forms/src/directives/ng_control_status';
export class Wrapper_SaraInputA2Component {
  /*private*/ _eventHandler:Function;
  context:import0.SaraInputA2Component;
  /*private*/ _changed:boolean;
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  /*private*/ _expr_2:any;
  /*private*/ _expr_3:any;
  /*private*/ _expr_4:any;
  /*private*/ _expr_5:any;
  /*private*/ _expr_6:any;
  subscription0:any;
  constructor() {
    this._changed = false;
    this.context = new import0.SaraInputA2Component();
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
    this._expr_2 = import1.UNINITIALIZED;
    this._expr_3 = import1.UNINITIALIZED;
    this._expr_4 = import1.UNINITIALIZED;
    this._expr_5 = import1.UNINITIALIZED;
    this._expr_6 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
    (this.subscription0 && this.subscription0.unsubscribe());
  }
  check_messages(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.messages = currValue;
      this._expr_0 = currValue;
    }
  }
  check_error(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this._changed = true;
      this.context.error = currValue;
      this._expr_1 = currValue;
    }
  }
  check_name(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_2,currValue))) {
      this._changed = true;
      this.context.name = currValue;
      this._expr_2 = currValue;
    }
  }
  check_maxlength(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_3,currValue))) {
      this._changed = true;
      this.context.maxlength = currValue;
      this._expr_3 = currValue;
    }
  }
  check_minlength(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_4,currValue))) {
      this._changed = true;
      this.context.minlength = currValue;
      this._expr_4 = currValue;
    }
  }
  check_required(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_5,currValue))) {
      this._changed = true;
      this.context.required = currValue;
      this._expr_5 = currValue;
    }
  }
  check_model(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_6,currValue))) {
      this._changed = true;
      this.context.model = currValue;
      this._expr_6 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any,emit0:boolean):void {
    this._eventHandler = _eventHandler;
    if (emit0) { (this.subscription0 = this.context.modelChange.subscribe(_eventHandler.bind(view,'modelChange'))); }
  }
}
var renderType_SaraInputA2Component_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_SaraInputA2Component_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.SaraInputA2Component>;
  _SaraInputA2Component_0_3:Wrapper_SaraInputA2Component;
  __NG_VALUE_ACCESSOR_0_4:any[];
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_SaraInputA2Component_Host0,renderType_SaraInputA2Component_Host,import6.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  get _NG_VALUE_ACCESSOR_0_4():any[] {
    if ((this.__NG_VALUE_ACCESSOR_0_4 == null)) { (this.__NG_VALUE_ACCESSOR_0_4 = [this._SaraInputA2Component_0_3.context]); }
    return this.__NG_VALUE_ACCESSOR_0_4;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'sara-input-a2',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_SaraInputA2Component0(this.viewUtils,this,0,this._el_0);
    this._SaraInputA2Component_0_3 = new Wrapper_SaraInputA2Component();
    this.compView_0.create(this._SaraInputA2Component_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import8.ComponentRef_<any>(0,this,this._el_0,this._SaraInputA2Component_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.SaraInputA2Component) && (0 === requestNodeIndex))) { return this._SaraInputA2Component_0_3.context; }
    if (((token === import9.NG_VALUE_ACCESSOR) && (0 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_0_4; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._SaraInputA2Component_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
    this._SaraInputA2Component_0_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const SaraInputA2ComponentNgFactory:import8.ComponentFactory<import0.SaraInputA2Component> = new import8.ComponentFactory<import0.SaraInputA2Component>('sara-input-a2',View_SaraInputA2Component_Host0,import0.SaraInputA2Component);
const styles_SaraInputA2Component:any[] = ([] as any[]);
class View_SaraInputA2Component1 extends import2.AppView<any> {
  _el_0:any;
  _NgClass_0_3:import10.Wrapper_NgClass;
  _text_1:any;
  /*private*/ _expr_3:any;
  _map_4:any;
  /*private*/ _expr_5:any;
  _pipe_translate_0:import11.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import12.ViewContainer) {
    super(View_SaraInputA2Component1,renderType_SaraInputA2Component,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_3 = import1.UNINITIALIZED;
    this._map_4 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {'required-field': p0};
    });
    this._expr_5 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'label',new import3.InlineArray2(2,'class','eva-label-form eva-3-label-form -md'),(null as any));
    this._NgClass_0_3 = new import10.Wrapper_NgClass(this.parentView.parentView.injectorGet(import13.IterableDiffers,this.parentView.parentIndex),this.parentView.parentView.injectorGet(import14.KeyValueDiffers,this.parentView.parentIndex),new import15.ElementRef(this._el_0),this.renderer);
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import11.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import17.NgClass) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgClass_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_0_0_0:any = 'eva-label-form eva-3-label-form -md';
    this._NgClass_0_3.check_klass(currVal_0_0_0,throwOnChange,false);
    const currVal_0_0_1:any = this._map_4(this.parentView.context.required);
    this._NgClass_0_3.check_ngClass(currVal_0_0_1,throwOnChange,false);
    this._NgClass_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_3:any = import3.inlineInterpolate(1,'eva-input-',this.parentView.context.name,'');
    if (import3.checkBinding(throwOnChange,this._expr_3,currVal_3)) {
      this.renderer.setElementProperty(this._el_0,'htmlFor',currVal_3);
      this._expr_3 = currVal_3;
    }
    valUnwrapper.reset();
    const currVal_5:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform(this.parentView.context.messages.name)),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_5,currVal_5))) {
      this.renderer.setText(this._text_1,currVal_5);
      this._expr_5 = currVal_5;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
var renderType_SaraInputA2Component:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,styles_SaraInputA2Component,{});
export class View_SaraInputA2Component0 extends import2.AppView<import0.SaraInputA2Component> {
  _el_0:any;
  _text_1:any;
  _anchor_2:any;
  /*private*/ _vc_2:import12.ViewContainer;
  _TemplateRef_2_5:any;
  _NgIf_2_6:import18.Wrapper_NgIf;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _DefaultValueAccessor_6_3:import19.Wrapper_DefaultValueAccessor;
  _RequiredValidator_6_4:import20.Wrapper_RequiredValidator;
  _MinLengthValidator_6_5:import20.Wrapper_MinLengthValidator;
  _MaxLengthValidator_6_6:import20.Wrapper_MaxLengthValidator;
  _NG_VALIDATORS_6_7:any[];
  _NG_VALUE_ACCESSOR_6_8:any[];
  _NgModel_6_9:import21.Wrapper_NgModel;
  _NgControl_6_10:any;
  _NgControlStatus_6_11:import22.Wrapper_NgControlStatus;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _text_10:any;
  _text_11:any;
  _text_12:any;
  /*private*/ _expr_25:any;
  /*private*/ _expr_26:any;
  _pipe_translate_0:import11.TranslatePipe;
  /*private*/ _expr_28:any;
  /*private*/ _expr_29:any;
  _pipe_translate_1:import11.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_SaraInputA2Component0,renderType_SaraInputA2Component,import6.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_25 = import1.UNINITIALIZED;
    this._expr_26 = import1.UNINITIALIZED;
    this._expr_28 = import1.UNINITIALIZED;
    this._expr_29 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._anchor_2 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_2 = new import12.ViewContainer(2,0,this,this._anchor_2);
    this._TemplateRef_2_5 = new import23.TemplateRef_(this,2,this._anchor_2);
    this._NgIf_2_6 = new import18.Wrapper_NgIf(this._vc_2.vcRef,this._TemplateRef_2_5);
    this._text_3 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','input-container'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n        ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'input',new import3.InlineArray4(4,'class','input-tag','type','text'),(null as any));
    this._DefaultValueAccessor_6_3 = new import19.Wrapper_DefaultValueAccessor(this.renderer,new import15.ElementRef(this._el_6));
    this._RequiredValidator_6_4 = new import20.Wrapper_RequiredValidator();
    this._MinLengthValidator_6_5 = new import20.Wrapper_MinLengthValidator();
    this._MaxLengthValidator_6_6 = new import20.Wrapper_MaxLengthValidator();
    this._NG_VALIDATORS_6_7 = [
      this._RequiredValidator_6_4.context,
      this._MinLengthValidator_6_5.context,
      this._MaxLengthValidator_6_6.context
    ]
    ;
    this._NG_VALUE_ACCESSOR_6_8 = [this._DefaultValueAccessor_6_3.context];
    this._NgModel_6_9 = new import21.Wrapper_NgModel((null as any),this._NG_VALIDATORS_6_7,(null as any),this._NG_VALUE_ACCESSOR_6_8);
    this._NgControl_6_10 = this._NgModel_6_9.context;
    this._NgControlStatus_6_11 = new import22.Wrapper_NgControlStatus(this._NgControl_6_10);
    this._text_7 = this.renderer.createText(this._el_4,'\n        ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_4,'span',new import3.InlineArray2(2,'class','info-msg'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'',(null as any));
    this._text_10 = this.renderer.createText(this._el_4,'\n    ',(null as any));
    this._text_11 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_12 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_6,new import3.InlineArray8(8,'ngModelChange',(null as any),'change',(null as any),'input',(null as any),'blur',(null as any)),this.eventHandler(this.handleEvent_6));
    this._NgModel_6_9.subscribe(this,this.eventHandler(this.handleEvent_6),true);
    this._pipe_translate_0 = new import11.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_1 = new import11.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.ref);
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._anchor_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._text_10,
      this._text_11,
      this._text_12
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import23.TemplateRef) && (2 === requestNodeIndex))) { return this._TemplateRef_2_5; }
    if (((token === import24.NgIf) && (2 === requestNodeIndex))) { return this._NgIf_2_6.context; }
    if (((token === import25.DefaultValueAccessor) && (6 === requestNodeIndex))) { return this._DefaultValueAccessor_6_3.context; }
    if (((token === import26.RequiredValidator) && (6 === requestNodeIndex))) { return this._RequiredValidator_6_4.context; }
    if (((token === import26.MinLengthValidator) && (6 === requestNodeIndex))) { return this._MinLengthValidator_6_5.context; }
    if (((token === import26.MaxLengthValidator) && (6 === requestNodeIndex))) { return this._MaxLengthValidator_6_6.context; }
    if (((token === import27.NG_VALIDATORS) && (6 === requestNodeIndex))) { return this._NG_VALIDATORS_6_7; }
    if (((token === import9.NG_VALUE_ACCESSOR) && (6 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_6_8; }
    if (((token === import28.NgModel) && (6 === requestNodeIndex))) { return this._NgModel_6_9.context; }
    if (((token === import29.NgControl) && (6 === requestNodeIndex))) { return this._NgControl_6_10; }
    if (((token === import30.NgControlStatus) && (6 === requestNodeIndex))) { return this._NgControlStatus_6_11.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_2_0_0:any = this.context.messages;
    this._NgIf_2_6.check_ngIf(currVal_2_0_0,throwOnChange,false);
    this._NgIf_2_6.ngDoCheck(this,this._anchor_2,throwOnChange);
    this._DefaultValueAccessor_6_3.ngDoCheck(this,this._el_6,throwOnChange);
    const currVal_6_1_0:any = this.context.required;
    this._RequiredValidator_6_4.check_required(currVal_6_1_0,throwOnChange,false);
    this._RequiredValidator_6_4.ngDoCheck(this,this._el_6,throwOnChange);
    const currVal_6_2_0:any = import3.inlineInterpolate(1,'',this.context.minlength,'');
    this._MinLengthValidator_6_5.check_minlength(currVal_6_2_0,throwOnChange,false);
    this._MinLengthValidator_6_5.ngDoCheck(this,this._el_6,throwOnChange);
    const currVal_6_3_0:any = import3.inlineInterpolate(1,'',this.context.maxlength,'');
    this._MaxLengthValidator_6_6.check_maxlength(currVal_6_3_0,throwOnChange,false);
    this._MaxLengthValidator_6_6.ngDoCheck(this,this._el_6,throwOnChange);
    const currVal_6_4_0:any = import3.inlineInterpolate(1,'feeName-',this.context.name,'');
    this._NgModel_6_9.check_name(currVal_6_4_0,throwOnChange,false);
    const currVal_6_4_1:any = this.context.model;
    this._NgModel_6_9.check_model(currVal_6_4_1,throwOnChange,false);
    this._NgModel_6_9.ngDoCheck(this,this._el_6,throwOnChange);
    this._NgControlStatus_6_11.ngDoCheck(this,this._el_6,throwOnChange);
    this._vc_2.detectChangesInNestedViews(throwOnChange);
    const currVal_25:any = import3.inlineInterpolate(2,'eva-3-input -md -validate -validate-sm ',((this.context.error == null)? (null as any): this.context.error.cssClass),' ',((this.context.error == null)? (null as any): this.context.error.cssClassPosition),'');
    if (import3.checkBinding(throwOnChange,this._expr_25,currVal_25)) {
      this.renderer.setElementProperty(this._el_0,'className',currVal_25);
      this._expr_25 = currVal_25;
    }
    valUnwrapper.reset();
    const currVal_26:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform(((this.context.messages == null)? (null as any): this.context.messages.placeholder))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_26,currVal_26))) {
      this.renderer.setElementProperty(this._el_6,'placeholder',currVal_26);
      this._expr_26 = currVal_26;
    }
    const currVal_28:any = import3.inlineInterpolate(1,'eva-input-',this.context.name,'');
    if (import3.checkBinding(throwOnChange,this._expr_28,currVal_28)) {
      this.renderer.setElementProperty(this._el_6,'id',currVal_28);
      this._expr_28 = currVal_28;
    }
    this._RequiredValidator_6_4.checkHost(this,this,this._el_6,throwOnChange);
    this._MinLengthValidator_6_5.checkHost(this,this,this._el_6,throwOnChange);
    this._MaxLengthValidator_6_6.checkHost(this,this,this._el_6,throwOnChange);
    this._NgControlStatus_6_11.checkHost(this,this,this._el_6,throwOnChange);
    valUnwrapper.reset();
    const currVal_29:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform(((this.context.error == null)? (null as any): this.context.error.message))),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_29,currVal_29))) {
      this.renderer.setText(this._text_9,currVal_29);
      this._expr_29 = currVal_29;
    }
  }
  destroyInternal():void {
    this._vc_2.destroyNestedViews();
    this._NgModel_6_9.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 2)) { return new View_SaraInputA2Component1(this.viewUtils,this,2,this._anchor_2,this._vc_2); }
    return (null as any);
  }
  handleEvent_6(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._DefaultValueAccessor_6_3.handleEvent(eventName,$event) && result);
    if ((eventName == 'ngModelChange')) {
      const pd_sub_0:any = ((<any>(this.context.model = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'change')) {
      const pd_sub_1:any = ((<any>this.context.updateValidation()) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/shared/sara-input/sara-input-a2.component.ngfactory.ts